import PropTypes from "prop-types";
import { RadioButton } from "is24-corecss-server";
import React from "react";
import styles from './RadioButtons.less'

const RadioButtons = ({ label, value, listOptions, groupName, onChange, oneLine, mobileLabel, labelClass, minGroupWidth }) => {
  const mobileLabelString = mobileLabel || label;
  if (oneLine) {
    return (
      <div className={`grid-item one-whole`}>
        <div className={'grid grid-flex'}>
          <div className={`grid-item ${styles.one_line_padding}`}>
            <label className={`input-label ${labelClass}`} id={`label-${groupName}`}>
              <span className={'palm-hide'}>{label}:</span>
              <span className={'desk-hide lap-hide'}>{mobileLabelString}:</span>
            </label>
          </div>
          <div className={'grid-item'}>
            <div className={styles.wrapper_radio_group} style={ { minWidth: minGroupWidth } }>
              {listOptions && listOptions.map((item, index) => (
                <div key={item.value} data-radio-button-last={ index === listOptions.length - 1}>
                  <RadioButton
                    label={item.name}
                    id={`${groupName}_${item.value}`}
                    name={groupName}
                    checked={value === item.value}
                    onChange={onChange}
                    value={item.value}
                  />
                </div>
              )) }
            </div>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className={`grid-item desk-one-whole lap-one-whole palm-one-half`}>
      <label className={`input-label ${labelClass}`} id={`label-${groupName}`}>{label}:</label>
      <div className={styles.wrapper_radio_group} style={ { minWidth: minGroupWidth } }>
        {listOptions && listOptions.map((item) => (
          <div key={item.value}>
            <RadioButton
              label={item.name}
              id={`${groupName}_${item.value}`}
              name={groupName}
              checked={value === item.value}
              onChange={onChange}
              value={item.value}
            />
          </div>
        )) }
      </div>
    </div>
  );
}

RadioButtons.defaultProps = {
  label: "",
  oneLine: false,
  mobileLabel: "",
  labelClass: "",
  minGroupWidth: "unset"
};

RadioButtons.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  listOptions:PropTypes.array,
  groupName: PropTypes.string,
  oneLine: PropTypes.bool,
  mobileLabel: PropTypes.string,
  labelClass: PropTypes.string,
  minGroupWidth: PropTypes.string,
};

export default RadioButtons
